// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2VQSH","label":"Labeled_label__1V9Ar","divider":"Labeled_divider__1yJdI"};